import React, { useEffect } from 'react';
import {
  HotelCard,
  HotelCardSmall,
  MapHotelCard,
  MapHotelCardSmall,
} from 'src/components/HotelCard';
import { getHotelCardProps, getMapHotelCardProps } from '../utils';
import type { IHotelRendererProps } from '../types';

const HotelRenderer = (props: IHotelRendererProps) => {
  const { isMobile, isMapCard, getImages } = props;

  useEffect(() => {
    getImages?.();
  }, [getImages]);

  if (isMapCard) {
    const mapHotelCardProps = getMapHotelCardProps(props);
    const Component = isMobile ? MapHotelCardSmall : MapHotelCard;

    return <Component {...mapHotelCardProps} />;
  }

  const hotelCardProps = getHotelCardProps(props);
  const Component = isMobile ? HotelCardSmall : HotelCard;

  return <Component {...hotelCardProps} />;
};

export default React.memo(HotelRenderer);
